import { useEffect } from "react";
import { useMatchRoute, useNavigate } from "@tanstack/react-router";
import { activeCall, useActiveCall } from "../../room/active-call";

// The live call to surface while the user is on any route but its own room, or
// null. A call that is still loading or failed to join has nothing to show.
export function useAwayCall() {
  const call = useActiveCall();
  const matchRoute = useMatchRoute();
  if (!call?.controller || call.error) return null;
  if (matchRoute({ to: "/room/$roomId", params: { roomId: call.roomId } })) return null;
  return { roomId: call.roomId, controller: call.controller };
}

// A join or fatal error that lands while away has no error screen; report it on
// home and drop the record so entering the room starts a fresh join.
export function useReportFailedAwayCall() {
  const call = useActiveCall();
  const matchRoute = useMatchRoute();
  const navigate = useNavigate();
  const failed =
    call?.error && !matchRoute({ to: "/room/$roomId", params: { roomId: call.roomId } })
      ? call
      : null;
  useEffect(() => {
    // Leaving the room's own error screen already discarded the record.
    if (!failed || activeCall.getState().call !== failed) return;
    activeCall.discardFailed(failed.roomId);
    void navigate({ to: "/", search: { ended: failed.error }, replace: true });
  }, [failed, navigate]);
}
